import {
  WillyQuotaResponse
} from '@TheGreenHouseCompany/vegiwise-sdk-typescript/dist/generated/@dto/responses/ai/willy-quota.response';

/** Ce que le décompte du jour autorise, et ce qu'il faut en montrer. */
export interface WillyQuotaView {
  /** Questions encore disponibles aujourd'hui. */
  remaining: number;
  /** Afficher le décompte discret au-dessus de la saisie. */
  showChip: boolean;
  /** Le mur est atteint : plus rien ne partira aujourd'hui. */
  exhausted: boolean;
}

/**
 * Lecture du décompte de Willy, hors de tout composant.
 *
 * Trois règles, et elles se tiennent toutes les trois à la même exigence : ne
 * rien afficher qui ne soit certain.
 *
 * - Sans décompte connu (appel en échec, invité), on ne montre NI compteur NI
 *   mur : le serveur refusera de lui-même s'il le faut, avec son message.
 * - Un abonné n'a pas de quota. Son plafond d'usage équitable existe contre
 *   l'automatisation, et le lui montrer démentirait l'illimité promis.
 * - Le compteur n'apparaît qu'après la première question du jour. Annoncer
 *   « 10/10 » avant d'avoir servi, c'est agiter une limite en guise d'accueil.
 */
export function readWillyQuota(
  quota: WillyQuotaResponse | null | undefined,
  isPremium: boolean,
): WillyQuotaView {
  const counted = Boolean(quota && !quota.unlimited && !isPremium);
  const remaining = quota ? Math.max(0, quota.limit - quota.used) : 0;

  return {
    remaining,
    showChip: counted && (quota?.used ?? 0) > 0 && remaining > 0,
    exhausted: counted && remaining === 0,
  };
}
